import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-finalize-signature',
    templateUrl: './signature.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutFinalizeSignatureComponent implements OnInit {
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<Blob> = new EventEmitter();

    constructor(
    ) {
    }

    ngOnInit(): void {
    }

    public cancelSignature(): void {
        this.emitCancel.emit();
    }

    public completeSignature(data: Blob): void {
        this.emitComplete.emit(data);
    }
}